import { render } from "./sales-location.vue?vue&type=template&id=56ef5803"
import script from "./sales-location.vue?vue&type=script&lang=js"
export * from "./sales-location.vue?vue&type=script&lang=js"

import exportComponent from "/Users/brunocarvalho/Projetos/admin-colegio-encanto-juvenil/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__